import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
import { BFormGroup, BTable, BForm } from "bootstrap-vue";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
export default {
  name: "pointsAndLevel",
  components: {
    CustomerSearch,
    BTable,
    BFormGroup,
    ExcelDownload,
    BForm,
  },
  data() {
    return {
      selectedCustomer: "",
      disabled: false,
      url: "admin/customers_club/level_users",
      items: [],
      fields: [
        {
          label: "ردیف",
          key: "index",
        },
        {
          label: "کاربر",
          key: "full_name",
        },
        {
          label: "شماره موبایل",
          key: "mobile",
        },
        {
          label: "سطح",
          key: "customers_club_level",
        },
        {
          label: "امتیاز",
          key: "customers_club_score",
        },
        {
          label: "بن",
          key: "customers_club_bon",
        },
      ],
      form: {
        customer_id: "",
        from_date: "",
        to_date: "",
      },
    };
  },
  watch: {
    "$route.query": function(newValue) {
      this.loadUserPointsAndLevelsList();
    },
  },
  methods: {
    async loadUserPointsAndLevelsList() {
      this.disabled = true;
      let page = this.$route.query.page || 1;
      await this.$axios
        .post(this.url, null, {
          params: {
            page: page,
            customer_id: this.form.selectedCustomer
              ? this.form.selectedCustomer.id
              : "",
            from_date: this.form.from_date,
            to_date: this.form.to_date,
          },
        })
        .then((res) => {
          this.items = res.data.data.users;
          this.$root.notify(res.data.message, "success");
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    changePage(page) {
      if (this.disabled) {
        return;
      }
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, page: page },
      });
    },
  },
  computed: {
    extraQuery() {
      return {
        customer_id: this.form.selectedCustomer
          ? this.form.selectedCustomer.id
          : "",
        from_date: this.form.from_date,
        to_date: this.form.to_date,
      };
    },
  },
};
